import { render, staticRenderFns } from "./SnapchatUpsellBanner.vue?vue&type=template&id=15e858aa&scoped=true&"
import script from "./SnapchatUpsellBanner.vue?vue&type=script&lang=js&"
export * from "./SnapchatUpsellBanner.vue?vue&type=script&lang=js&"
import style0 from "./SnapchatUpsellBanner.vue?vue&type=style&index=0&id=15e858aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e858aa",
  null
  
)

export default component.exports